// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3eqao","select":"Header_select__2v_33","clinic":"Header_clinic__UtbZs"};